export const optionalFieldLabel = (label: string): string => `${label} (Optional)`;
